module.exports = __webpack_public_path__ + "img/logoNew.ce0bc64c.png";